import React, {useMemo} from "react";
import Modal from "../../common/components/modules/modal/Modal";
import {ModalBackButton} from "../../common/components/modules/modal/modalComponents";
import useRouter from "../../common/hooks/useRouter";
import UserProfileMerrcoCardSelectionField from "src/core/payments/merrco/UserProfileMerrcoCardSelectionField";
import {Form} from "react-final-form";
import styled from "styled-components";
import {FormHeader} from "../../common/components/collections/form/forms";
import {makePayment} from "../../payments/factory";
import {isClient} from "src/server/utils/isClient";
import AuthenticationRequiredComponent from "src/core/common/components/utils/AuthenticationRequiredComponent";
import UserProfileMonerisCardSelectionField from "src/core/payments/moneris/UserProfileMonerisCardSelectionField";
import routes from "src/core/common/routes";

function CardPaymentMethodsModal({isOpen, closeModal, paymentType}) {
  const router = useRouter();
  const paymentOption = useMemo(() => isClient && makePayment(paymentType), []);

  function onBack() {
    router.replace(routes.myAccount);
  }
  async function onSubmit(formValues) {
    await paymentOption.addAccount(formValues.payment);
    onBack();
  }

  return (
    <>
      <Modal isOpen={isOpen} closeModalOverride={closeModal}>
        <ModalBackButton onClick={onBack} data-cy="modalBackButton" />
        <Form
          onSubmit={onSubmit}
          mutators={{
            setValue: ([field, value], state, {changeValue}) => {
              changeValue(state, field, () => value);
            },
          }}
          render={({form, handleSubmit}) => (
            <form onSubmit={handleSubmit}>
              <Container>
                <FormHeader>Cards</FormHeader>
                {paymentType === "merrco" && (
                  <UserProfileMerrcoCardSelectionField
                    form={form}
                    paymentOption={paymentOption}
                    readOnly={false}
                    disabled={false}
                    profile={true}
                    handleSubmit={handleSubmit}
                  />
                )}
                {paymentType === "moneris" && (
                  <UserProfileMonerisCardSelectionField
                    paymentOption={paymentOption}
                    form={form}
                  />
                )}
              </Container>
            </form>
          )}
        />
      </Modal>
    </>
  );
}

function CardPaymentMethodsModalWrapper(props) {
  const router = useRouter();
  const {creditCardType} = router.query;
  return (
    <AuthenticationRequiredComponent
      authenticationFailAction={() => {
        router.safeBack();
      }}
    >
      <CardPaymentMethodsModal {...props} paymentType={creditCardType} />
    </AuthenticationRequiredComponent>
  );
}

const Container = styled.form`
  width: 450px;
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: ${({theme}) => theme.v2.spacing(2)};
    width: 100%;
  }
`;

export default CardPaymentMethodsModalWrapper;
